/* unplugin-vue-components disabled */import { render } from "./Header.vue?vue&type=template&id=408f2125&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/liyankai6/Documents/project/print-open/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__